<div class="summary-container">
  <div class="ml-4 displayText" [innerHtml]="getVehicleDescription()"></div>
  <div>
    <img [src]="getImage()" (error)="setDefaultImg($event,'images/Sedan_Generic_base_default_34_f_d_490x280.png')"
      alt="Vehicle image">
  </div>
  <ng-container *ngIf="!isTelematicsLoading; else loading">

    <div class="telematics">
      <span [title]="getTelematicsTranslation(telematics?.smartKeyBatteryDegradationStatusHover)">
        <asp-icon name="icon-battery.svg" class="app-icon" color="inherit" width="1rem" height="1rem"></asp-icon>
        <span *ngIf="telematics?.smartKeyBatteryDegradationStatusToShow === '--';">
          {{ telematics?.smartKeyBatteryDegradationStatusToShow }}
        </span>
        <span *ngIf="telematics?.smartKeyBatteryDegradationStatusToShow.toUpperCase() === 'OK'">
          <ng-template [ngTemplateOutlet]="ok"></ng-template>
        </span>
        <span *ngIf="telematics?.smartKeyBatteryDegradationStatusToShow?.toUpperCase() === 'BAD'">
          <ng-template [ngTemplateOutlet]="bad"></ng-template>
        </span>
      </span>
      <span [title]="getTelematicsTranslation(telematics?.fuelHover)">
        <asp-icon name="ic-20-vin-fuel.svg" class="app-icon" color="inherit" width="1rem" height="1rem"></asp-icon>
        <span>{{ telematics?.fuel }}</span>
      </span>
      <span [title]="getTelematicsTranslation(telematics?.milesToEmptyDescriptionHover)">
        <asp-icon name="ic-20-vin-odometer.svg" class="app-icon" color="inherit" width="1rem" height="1rem"></asp-icon>
        <span>{{ telematics?.milesToEmptyDescription }}</span>
      </span>
      <span [title]="getTelematicsTranslation(telematics?.engineOilLevelStatusHover)">
        <asp-icon name="icon-engine-oil.svg" class="app-icon" color="inherit" width="1.2rem" height="1.2rem"></asp-icon>
        <span *ngIf="telematics?.engineOilLevelStatus === '--';">
          {{ telematics?.engineOilLevelStatus }}
        </span>
        <span *ngIf="telematics?.engineOilLevelStatus === '3';">
          <ng-template [ngTemplateOutlet]="ok"></ng-template>
        </span>
        <span *ngIf="telematics?.engineOilLevelStatus === '2';">
          <ng-template [ngTemplateOutlet]="bad"></ng-template>
        </span>
      </span>
      <span [title]="getTelematicsTranslation(telematics?.tirePressureStatusHover)">
        <asp-icon name="ic-20-vin-tire.svg" path="svg/" class="app-icon" color="inherit" width="1rem" height="1rem">
        </asp-icon>
        <span *ngIf="telematics?.tirePressureStatus?.toLowerCase() === '--';">
          {{ telematics?.tirePressureStatus }}
        </span>
        <span *ngIf="telematics?.tirePressureStatus?.toLowerCase() === 'ok';">
          <ng-template [ngTemplateOutlet]="ok"></ng-template>
        </span>
        <span *ngIf="telematics?.tirePressureStatus?.toLowerCase() === 'bad';">
          <ng-template [ngTemplateOutlet]="bad"></ng-template>
        </span>
      </span>
    </div>

  </ng-container>

  <ng-template #bad>
    <span>
      <asp-icon name="ic-red-cross.svg"
      path="svg/"
      class="app-icon"
      color="inherit"
      width="1rem"
      height="1rem"></asp-icon>
    </span>
  </ng-template>
  <ng-template #ok>
    <span>
      <asp-icon name="ic-green-tick.svg"
      path="svg/"
      class="app-icon"
      color="inherit"
      width="1rem"
      height="1rem"></asp-icon>
    </span>
  </ng-template>

  <ng-template #loading>
    <app-loading class="telematics-loading" loadingSymbol="dots" [text]="''"
      color="var(--dashboard-primary-color)" size=".75">
    </app-loading>
  </ng-template>

  <div *ngIf="!isMonthApptsLoading">
    <div class="upcoming-test-drive">{{ 'vehicleManagement.upcomingTestDrive' | translate}}</div>
    <div  class="upcoming-appt" [ngClass]="searchValues?.length > 0 ? 'withSearch' : ''">
    <div id="asp-fleet-calendar" class="calendar-container">
      <mat-calendar #fleetcalendar panelClass="endDate" [headerComponent]="customHeader"
        (selectedChange)="dateChange($event,calendar)" (monthSelected)="monthChange($event)" [minDate]="minDate"
        [dateClass]="dateClass" class="col-md-12">
      </mat-calendar>
    </div>
    <div class="appt-details">
    <div *ngIf="selectedDateAppts && selectedDateAppts[0]?.appointments?.length > 0" class="appt-list">
      <div *ngFor="let appt of selectedDateAppts[0]?.appointments">
        <div class="d-flex align-items-center pb-3 appt-row">
          <div>{{appt.timeSlotId}}</div>
          <div class="dot-space"> &#x2022; </div>
          <div>{{ getAppointmentCustomerDisplayName(appt.customer) }}</div>
        </div>
      </div>
  
    </div>
    <div *ngIf="selectedDate && !(selectedDateAppts[0]?.appointments?.length > 0)" class="no-appt">
      <mat-icon class="mat-icon">info_outline</mat-icon>
      <span class="label">{{ 'vehicleManagement.thereAreNoUpcomingTestDriveOnThisDay' | translate}}</span>
    </div>
    <div *ngIf="vehicle?.expiredAt && vehicle?.nextTestDriveDate" class="text-center delete-pending-msg">
      {{ 'vehicleManagement.thereAreUpcomingAppointmentsScheduledForThisDeletedVehiclePleaseMakeSureToModifyTheseAppointmentsInTheSalesScheduleScreen' | translate}}
    </div>
  </div>
  </div>
  </div>

</div>
